import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { BoldButton } from '@components/core-ui/form-elements/buttons/Button/variations/BoldButton';
import { Subscription } from '@modals/ASOne/ChooseASOneSubscriptionModal/components/Subscription';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import {
  AdminBillingAccountResponseDto,
  AdminService,
  BillingAccountService,
  GetAllSubscriptionPlansPlanResponseDto,
} from 'app/API';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { DescriptionBlock } from '../../ASOne/ChooseASOneSubscriptionModal/components/DescriptionBlock';
import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const AdminChooseASOneSubscriptionModal = ({ onCancel, onSuccess, billingAccountId }: TProps) => {
  const { call } = useAPI();
  const { updateMe } = useAuthContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [allPlans, setAllPlans] = useState<GetAllSubscriptionPlansPlanResponseDto[]>([]);
  const [plans, setPlans] = useState<GetAllSubscriptionPlansPlanResponseDto[]>([]);
  const [billingAccount, setBillingAccount] = useState<AdminBillingAccountResponseDto>();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setPlans([]);
      const billingAccount = await call(AdminService.getBillingAccount({ baId: billingAccountId }));
      setBillingAccount(billingAccount);
      const allPlans = await call(BillingAccountService.getAllAsOnePlans());
      setAllPlans(allPlans);
      setPlans(allPlans);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    setPlans(allPlans);
  }, []);

  const goToContactSales: React.MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.preventDefault();
    window.scroll(0, 0);
    navigate(routes.contactSales.make());
  };

  if (!billingAccount?.id) {
    return <></>;
  }

  const selectPlan = async (id: string) => {
    await updateMe();
    const plan = plans.find((item) => item.id === id);

    onSuccess({
      subscriptionProductId: id,
      planName: plan?.name ?? '',
      price: Number(plan?.price ?? 0),
      freeSeats: plan?.freeSeats || 0,
    });
  };

  const activeIds = (billingAccount?.subscriptions ?? [])
    .filter((sub) => {
      return sub.status === 'active' || sub.status === 'trialing';
    })
    .map((sub) => {
      return sub.productId;
    });
  const activePlans = plans.filter((plan) => {
    return activeIds.indexOf(plan.id) > -1;
  });
  const inactivePlans = plans.filter((plan) => {
    return activeIds.indexOf(plan.id) === -1;
  });

  return (
    <ModalWrapper width="570px" overflow="auto">
      {isLoading ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Pricing Plans</ModalTitle>
      <Content>
        <div className="scrollContainer">
          <div className="cardContainer">
            {activePlans.map((plan) => {
              return <Subscription key={plan.id} plan={plan} isActive={true} onChoose={() => selectPlan(plan.id)} />;
            })}
            {inactivePlans.map((plan) => {
              return <Subscription key={plan.id} plan={plan} isActive={false} onChoose={() => selectPlan(plan.id)} />;
            })}
          </div>
        </div>

        <DescriptionBlock />

        <div className="buttonModalContainer">
          <BoldButton onClick={goToContactSales}>Contact Our Sales Team</BoldButton>
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
        </div>
      </Content>
    </ModalWrapper>
  );
};
